<template>
  <div>
    <div class="row">
      <div class="pb-0 col-md-12">
        <h6 class="upper-text">
          Deseja realmente apagar o cuidado da prescrição?
        </h6>
      </div>

      <div class="col-md-12 pt-0 pb-0">
        <ErrorsMessages :errors="errors" />

        <div v-if="datesCheck && datesCheck.length > 0" class="border">
          <!-- Aqui verificar com o luiz oque fazer -->

          <!-- <h6 class="title-pages text-fifteen text-center border-bottom">
            DATA(S) QUE O MEDICAMENTO ESTÁ APENAS SEPARADO
          </h6>

          <div v-for="(date, key) in datesCheck" :key="key">
            <div class="d-flex align-items-center justify-content-center">
              <b class="mr-2">{{ formatDate(date, false) }}</b>

              <v-btn
                small
                @click="handleCheckDate(date)"
                class="mt-1 mb-1 v-primary"
              >
                <i class="fas fa-arrow-right mr-2"></i>
                ACESSAR
              </v-btn>
            </div>
          </div> -->
        </div>

        <div v-else class="col-md-12 text-right">
          <v-btn
            :disabled="loading"
            @click="deletePrescriptionCare"
            class="btn-delete"
            ><i class="fas fa-trash mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "EXCLUIR" }}</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

import { formatDateToUs, formatDate } from "../../../lib/format";

export default {
  name: "CareDelete",

  components: {
    ErrorsMessages,
  },

  props: {
    id: [String, Number],

    prescription_care: { type: Object },

    group_prescription_care: { type: Object },
  },

  data() {
    return {
      end: "",

      resident_id: "",

      datesCheck: [],

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDateToUs,

    formatDate,

    async retrieve() {
      const { prescription_care } = this;

      this.resident_id = prescription_care.resident_id;
    },

    async deletePrescriptionCare() {
      try {
        this.loading = true;

        let { id, resident_id } = this;

        let data = { id, resident_id };

        const response = await api.delete("/rest-home/prescription-care", {
          data,
        });

        const { error, errors, message, dates } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("delete", "paginate");

          this.errors = [];

          this.datesCheck = [];
        } else {
          this.errors = errors;

          this.datesCheck = dates;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    handleCheckDate(date) {
      let route = this.$router.resolve({
        name: "resident",
        query: { tab: "check", nav: "check", date },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
